<template>
  <div>
    <form novalidate @submit.prevent="submit">
      <div class="row text-center">
        <div
          class="caixa-login col-xs-offset-2 col-sm-offset-4 col-md-offset-4 col-lg-offset-4 col-xs-8 col-sm-4 col-md-4 col-lg-4"
        >
          <h1 id="logo" class="logo"> cardea </h1>
          <br /><br />
          <div
            id="emailGroup"
            :class="{ 'has-error': v$.user.email.$error }"
            class="form-group"
          >
            <label class="sr-only" for="username"> E-mail </label>
            <div class="input-group">
              <div class="input-group-addon">
                <i class="fa fa-user" aria-hidden="true" />
              </div>
              <input
                id="email"
                v-model="user.email"
                data-test-id="input-login-email"
                type="email"
                name="email"
                class="form-control"
                placeholder="E-mail"
                @input="v$.user.email.$touch()"
              />
            </div>
          </div>
          <div
            id="passwordGroup"
            :class="{ 'has-error': v$.user.password.$error }"
            class="form-group"
          >
            <label class="sr-only" for="password"> Senha </label>
            <div class="input-group">
              <div class="input-group-addon">
                <i class="fa fa-lock" aria-hidden="true" />
              </div>
              <input
                id="password"
                v-model="user.password"
                data-test-id="input-login-senha"
                type="password"
                name="password"
                class="form-control"
                placeholder="Senha"
                @input="v$.user.password.$touch()"
              />
            </div>
          </div>
          <div class="text-right" style="margin: 0 0 12px 0">
            Esqueceu a senha?
            <RouterLink
              data-test-id="link-esqueci-senha"
              :to="'/esqueci-senha'"
            >
              Clique aqui.
            </RouterLink>
          </div>
          <button
            id="entrar"
            data-test-id="button-login-entrar"
            type="submit"
            class="btn btn-primary btn-block"
          >
            Entrar
          </button>
          <br />
          <br />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { email, required } from '@vuelidate/validators'

import { useMenu } from '@/composables/useMenu'
import router from '@/router'
import Autenticacao from '@/servicos/Autenticacao'

const autenticacao = new Autenticacao()

const menuAtual = { descricao: 'Login', breadcrumb: [] }

export default {
  name: 'Login',
  setup() {
    useMenu(menuAtual)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      user: {
        email: '',
        password: '',
        ultimoLogin: new Date(),
      },
    }
  },
  methods: {
    submit() {
      if (this.v$.user.$invalid) {
        this.v$.$touch()
        this.$alert({ content: 'Informe o email e a senha.' })
      } else {
        autenticacao.login(this.user).then((result) => {
          router.replace({ name: 'Agendamento' })
        })
      }
    },
  },
  validations: {
    user: {
      email: { required, email },
      password: { required },
    },
  },
}
</script>

<style scoped>
.caixa-login {
  padding: 50px 50px 10px 50px !important;
  margin-top: 40px;
  background-color: #f7f9f9;
  box-shadow: 0 6px 32px rgba(0, 0, 0, 0.175);
}

.logo {
  position: relative;
  display: inline;
  margin-left: -36px;
  font-family: 'Crushed', Arial, Helvetica, sans-serif !important;
  font-size: 8em;
  font-weight: 400px;
  color: rgba(18, 128, 128, 0.5);
  letter-spacing: -7px;
}

.logo::after {
  position: absolute;
  top: 4px;
  left: 7px;
  color: rgba(128, 128, 18, 0.5);
  content: 'cardea';
}
</style>
